import { Component, OnInit, ViewChild } from '@angular/core';

// Interfaces
import { IAnalisisCompactacion } from 'src/app/interfaces/analisis_compactacion';
import { ICliente } from 'src/app/interfaces/cliente';
import { IAlmacen } from 'src/app/interfaces/almacenes';

// Servicios
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { StockService } from 'src/app/services/datos/stock.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { AlmacenesService } from 'src/app/services/datos/almacenes.service';

// Librerías y funciones
import { environment } from 'src/environments/environment';
import FuncLib from 'src/app/providers/funcionesLib';
import { ColumnMode } from '@swimlane/ngx-datatable';
import * as XLSX from 'xlsx';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-compactacion-analisis',
  templateUrl: './compactacion-analisis.component.html',
  styleUrls: ['./compactacion-analisis.component.scss']
})

export class CompactacionAnalisisComponent implements OnInit {

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  public fotoDir: string = environment.fotoDir;
  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';
  imagenSeleccionada: string | null = null;

  listaAnalisis: IAnalisisCompactacion[] = [];
  public rows: any = [];
  public temp: any[] = [];

  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  textoDestacado: string = '';
  loading = false;

  clienteSeleccionado: number | null = 0;
  severidadSeleccionada: string | null = null;
  clientesList: ICliente[] = [];

  eanSeleccionado: string | null = null;
  eanList: string[] = [];

  almacenesList: IAlmacen[] = [];
  almacenSeleccionado: number | null = 0;

  // Plan de optimización
  public planData: any = {};
  public planMovimientos: any[] = [];
  public mostrarModalPlan: boolean = false;


  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado'
  }

  ColumnMode = ColumnMode;
  @ViewChild(CompactacionAnalisisComponent) table: CompactacionAnalisisComponent | any;

  constructor(
    public notificSrv: NotificacionesService,
    private stockSrv: StockService,
    private clientesSrv: ClientesService,
    private almacenesSrv: AlmacenesService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {

    // Suscribirse a los parámetros de la url, si envían una id_cliente, cargar los datos del cliente
    this.activatedRoute.params.subscribe(({ id_cliente }) => {
      if (id_cliente) {
        this.clienteSeleccionado = id_cliente;
        this.cargarAnalisis();
      }
    });

    this.getClientesList();
    this.getAlmacenesList();
  }

  cargarAnalisis() {
    this.listaAnalisis = [];
    this.rows = [];
    this.temp = [];

    if (!this.clienteSeleccionado || this.clienteSeleccionado == 0) return;

    let almacenApi: number | null = this.almacenSeleccionado;
    if (this.almacenSeleccionado == 0) {
      console.log('__cargarAnalisis() para Todos los almacenes');
      almacenApi = null;
    }

    const opciones = {
      id_cliente: this.clienteSeleccionado,
      id_almacen: almacenApi
    }
    this.loading = true;
    this.stockSrv.getAnalisisCompactacion(opciones).subscribe({
      next: (resp: any) => {
        this.loading = false;

        console.log('__cargarAnalisis() resp:', resp);

        if (resp.error) {
          this.notificSrv.aviso('error', resp.mensaje);
          return;
        }
        this.listaAnalisis = resp.data;

        this.rows = this.listaAnalisis;
        this.temp = [...this.listaAnalisis];


        // lista de eans 
        this.eanList = [];
        this.listaAnalisis.map((e: any) => {
          this.eanList.push(e.articulo_ean);
        });
        // quitar duplicados y ordenar 
        this.eanList.sort((a, b) => a.localeCompare(b));

        // si no hay datos , mostrar mensaje
        if (this.temp.length === 0) {
          this.notificSrv.aviso('info', resp.mensaje);
        }
      },
      error: (err) => {
        console.error('Error al cargar análisis:', err);
        this.loading = false;
      }
    });
  }


  // Obtener plan de optimización
  obtenerPlan(articulo: IAnalisisCompactacion) {
    this.planMovimientos = [];
    this.mostrarModalPlan = false;

    console.log('__Solicitando plan para:', articulo);

    const opciones = {
      id_articulo: articulo.id_articulo!,
      id_almacen: 51,
      id_cliente: this.clienteSeleccionado!,
      capacidad_historica: articulo.capacidad_historica || 0,
      generarPdf: 0
    };

    this.loading = true;

    this.stockSrv.generarPlanCompactacion(opciones).subscribe({
      next: (resp: any) => {
        this.loading = false;
        console.log('__generarPlanCompactacion() resp:', resp);

        if (resp.error) {
          this.notificSrv.aviso('error', resp.mensaje);
          this.mostrarModalPlan = false;
          return;
        }

        this.planData = resp.data;
        this.planData.totales = resp.totales;

        this.planMovimientos = this.planData.plan_movimientos || [];
        console.log('__planMovimientos:', this.planMovimientos);

        this.mostrarModalPlan = true;

      },
      error: (err) => {
        console.error('---> Error al obtener plan:', err);
        this.loading = false;
      }
    });

  }

  asignarPlanUsuario() {
    console.log('__Asignando plan para:', this.planData);
  }

  generarPdfPlan() {
    this.loading = true;

    const opciones = {
      id_articulo: this.planData.totales.dataIn.id_articulo!,
      id_almacen: this.planData.totales.dataIn.id_almacen!,
      id_cliente: this.planData.totales.dataIn.id_cliente!,
      capacidad_historica: this.planData.totales.dataIn.capacidad_historica!,
      generarPdf: 1
    };

    this.stockSrv.generarPlanCompactacion(opciones).subscribe({
      next: (resp: any) => {
        this.loading = false;
        console.log('__generarPlanCompactacion() resp:', resp);

        if (resp.error) {
          this.notificSrv.aviso('error', resp.mensaje);
          this.mostrarModalPlan = false;
          return;
        }

        // abrir pdf en nueva pestaña 
        const urlPdf: string = environment.pdfDir + '/work/' + resp.totales.nombrePdf;
        window.open(urlPdf, '_blank');

      },
      error: (err) => {
        console.error('---> Error al obtener plan:', err);
        this.loading = false;
      }
    });


  }

  // Listas de datos

  getAlmacenesList() {
    this.loading = true;
    this.almacenesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }
      this.almacenesList = resp.data;
      this.almacenesList.unshift({ id: 0, nombre: 'Todos' } as IAlmacen);
    });
  }

  getClientesList() {
    this.loading = true;
    this.clientesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
      this.clientesList.unshift({ id: 0, nombre: 'Selecciona Cliente...' } as ICliente);
    });
  }


  // Eventos de cambio de selección en los Selects

  onCambiaCliente() {
    console.log('__onCambiaCliente() this.clienteSeleccionado:', this.clienteSeleccionado);
    this.severidadSeleccionada = null;
    this.eanSeleccionado = null;
    this.cargarAnalisis();
  }

  onCambiaAlmacen() {
    console.log('onCambiaAlmacen() this.almacenSeleccionado:', this.almacenSeleccionado);
    this.severidadSeleccionada = null;
    this.eanSeleccionado = null;
    this.cargarAnalisis();
  }

  onSeveridadChange() {
    // aplicar filtro a temp por severidad
    console.log('onSeveridadChange() this.severidadSeleccionada:', this.severidadSeleccionada);
    if (this.severidadSeleccionada === null) {
      this.rows = this.temp;
      return;
    }
    this.rows = this.temp.filter((item: any) =>
      item.severidad === this.severidadSeleccionada
    );
    this.eanSeleccionado = null;
  }

  onCambiaEan() {
    // aplicar filtro a temp por ean
    console.log('onCambiaEan() this.eanSeleccionado:', this.eanSeleccionado);
    if (this.eanSeleccionado === null) {
      this.rows = this.temp;
      return;
    }
    this.rows = this.temp.filter((item: any) =>
      item.articulo_ean === this.eanSeleccionado
    );
    this.severidadSeleccionada = null;
  }




  // Aux  //

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr); // convertir el valor a número
  }


  buscarTodo(event: any) {
    const txt = event?.target?.value?.toString().toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some((key: any) =>
        d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );
    this.textoDestacado = txt;
    this.rows = temp;
    this.table = this.listaAnalisis;
  }


  // Modal imágen
  abrirPopupImagen(url: string) {
    console.log('__abrirPopupImagen()', url);
    if (url.includes('_noFoto')) return
    this.imagenSeleccionada = url;
  }

  cerrarPopupImagen() {
    this.imagenSeleccionada = null;
  }


  // EXPORTAR A EXCEL
  exportToExcel(): void {
    const fileName = `Analisis-Compactacion-Stock-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }


}
